/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapPrintOptions } from './print-options.model';

export class SetPrintOptions {
    static readonly type = '[Print] Set print options';

    constructor(public payload: Partial<MapPrintOptions>) {}
}
